import { createAction } from "redux-act";
import * as app from "./app";

// LOAD
const LOAD_TREATMENT_CODES_REQUEST = `${app.NS}account/load_treatment_codes_request`;
export const LOAD_TREATMENT_CODES_REQUEST_ACTION = createAction(
  LOAD_TREATMENT_CODES_REQUEST
);

export const loadTreatmentCodesRequest = (payload = {}) => {
  const action = LOAD_TREATMENT_CODES_REQUEST_ACTION(payload);
  return action;
};

// SAVE
const SAVE_TREATMENT_CODE_FORM_REQUEST = `${app.NS}account/save_treatment_code_form_request`;
export const SAVE_TREATMENT_CODE_FORM_REQUEST_ACTION = createAction(
  SAVE_TREATMENT_CODE_FORM_REQUEST
);

const SAVE_TREATMENT_CODE_FORM_SUCCESS = `${app.NS}account/save_treatment_code_form_success`;
export const SAVE_TREATMENT_CODE_FORM_SUCCESS_ACTION = createAction(
  SAVE_TREATMENT_CODE_FORM_SUCCESS
);

const SAVE_TREATMENT_CODE_FORM_FAILURE = `${app.NS}account/save_treatment_code_form_failure`;
export const SAVE_TREATMENT_CODE_FORM_FAILURE_ACTION = createAction(
  SAVE_TREATMENT_CODE_FORM_FAILURE
);

// Delete Treatment Code
const DELETE_TREATMENT_CODE_REQUEST = `${app.NS}account/delete_treatment_code_request`;
export const DELETE_TREATMENT_CODE_REQUEST_ACTION = createAction(
  DELETE_TREATMENT_CODE_REQUEST
);

export const deleteTreatmentCodeRequest = payload => {
  return DELETE_TREATMENT_CODE_REQUEST_ACTION(payload);
};

export const saveTreatmentCodeFormRequest = payload => {
  return SAVE_TREATMENT_CODE_FORM_REQUEST_ACTION(payload);
};

export const saveTreatmentCodeFormSuccess = payload => {
  return SAVE_TREATMENT_CODE_FORM_SUCCESS_ACTION(payload);
};

export const saveTreatmentCodeFormFailure = error => {
  return SAVE_TREATMENT_CODE_FORM_FAILURE_ACTION(error);
};

export const saveTreatmentCodeRequest = payload => {
  return saveTreatmentCodeFormRequest(payload);
};



// WEBPACK FOOTER //
// ./src/ducks/treatmentCode.js